/**
 * Gets the user's timezone from the browser.
 *
 * Uses Intl.DateTimeFormat to detect the timezone automatically.
 * Falls back to 'America/Los_Angeles' if detection fails (company is US-based).
 *
 * @author Milton Filho
 * @returns The IANA timezone identifier (e.g., 'America/New_York', 'America/Los_Angeles')
 */
export const getUserTimezone = (): string => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone || 'America/Los_Angeles';
  } catch {
    return 'America/Los_Angeles';
  }
};
